//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { WebsiteMediumSVG } from './svg'

interface WebsiteMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
}

export const WebsiteMediumIcon: React.FC<WebsiteMediumIconProps> = forwardRef<
  WebsiteMediumIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx, ariaLabel }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    aria-label={ariaLabel}
    as={WebsiteMediumSVG}
    sx={sx}
  />
))
